module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true, 'has-errors': _vm.fieldErrors
    }
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ninja-input"
  }, [(_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }, _vm.handleInput],
      "keydown": _vm.handleKeyDown,
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.handleInput,
      "keydown": _vm.handleKeyDown,
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.fieldErrors) ? _c('ul', {
    staticClass: "form-errors"
  }, _vm._l((_vm.fieldErrors), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ninja-bars"
  }, [_c('div', {
    staticClass: "ninja-bar ninja-focus"
  }), _vm._v(" "), _c('div', {
    staticClass: "ninja-bar ninja-error"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57161c90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/FormText.vue
// module id = 220
// module chunks = 1